import useCrmContext from 'hooks/useCrmContext';
import useTasksChanged from 'hooks/useTasksChanged';
import { useCallback, useEffect, useState } from 'react';
import crmApi from 'server/crm/crmApi';

/**
 * The comments that name the signed-in user, the latest first
 * (server/crm/crmApi `getMentions`), read again whenever the tasks change: a
 * task opened reads its mentions. `mentions` is null while they are read;
 * `me` names the user in their text.
 */
const useMentions = () => {
  const { call, me, ready } = useCrmContext();
  const [mentions, setMentions] = useState(null);
  const [failed, setFailed] = useState(false);

  const load = useCallback(() => {
    if (!ready) return;
    call(crmApi.getMentions).then(
      (list) => {
        setMentions(list);
        setFailed(false);
      },
      () => setFailed(true),
    );
  }, [call, ready]);
  useEffect(load, [load]);
  useTasksChanged(load);

  return { mentions, failed, me, reload: load };
};

export default useMentions;
